import { getLocaleDate } from './date/get-locale-date.helper';
import { config } from 'packages/config';

const getHolterFileName = (patientName = 'no patient name', fileExtension: string) => {
  const utcDate = getLocaleDate(Date.now(), 'DD-MM-YYYY, HH:mm');

  return `${config.ENV.APP.ENVIRONMENT}/${patientName}/${patientName}.${utcDate}.${fileExtension}`;
};

export { getHolterFileName };
